import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import QuoteSection from "./components/QuoteSection";
import ProblemsSection from "./components/ProblemsSection";
import ProductsSection from "./components/ProductsSection";
import DataFlowSection from "./components/DataFlowSection";
import BespokeSection from "./components/BespokeSection";
import OverviewSection from "./components/OverviewSection";
import IndustriesSection from "./components/IndustriesSection";
import GetFitCarousel from "./components/GetFitCarousel";
import GainsSection from "./components/GainsSection";
import AdvisorCTASection from "./components/AdvisorCTASection";
import PricingSection from "./components/PricingSection";
import FinalCTASection from "./components/FinalCTASection";
import ContactSection from "./components/ContactSection";
import { usePageMeta } from "../../hooks/usePageMeta";

export default function Home() {
  usePageMeta(
    "StackMap Systems | Operational Infrastructure for Scale",
    "StackMap provides off-the-shelf and bespoke SaaS solutions that help organizations manage people, operations, performance, billing, and workflows from one intelligent platform."
  );

  return (
    <div className="min-h-screen bg-graphite-900">
      <Navbar />
      <main>
        <HeroSection />
        <QuoteSection />
        <ProblemsSection />
        <ProductsSection />
        <DataFlowSection />
        <BespokeSection />
        <OverviewSection />
        <IndustriesSection />
        <GetFitCarousel />
        <GainsSection />
        <AdvisorCTASection />
        <PricingSection />
        <FinalCTASection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
